/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
import { getDayWithFormat } from "../../../../../../../../../../utils/getDate"
import { getFullName } from "../../../../../../../../../../utils/getFullName"
import { getValueByLanguage } from "../../../../../../../../../../utils/getValueByLanguage"
import { SchedulesListDataType } from "../../../../../../../models/list"
import { SchedulesExportExcelFRM304Type } from "../../../../../../../models/list/export"
import { Timezone } from "../../../../../../../../../../constant/Timezone"
import { getDispatchTypeDetailName } from "../../../../../../../../../../utils/getDispatchTypeDetailName"
import { Variables } from "../../../../../../../../travelers/constants/edit/variables"

const { DATE_FORMAT_EN } = Timezone
const { KEYS_ACCOMPANYING_FAMILY } = Variables

const getDisplayDateTime = (csvDateTime: string) => {
  return csvDateTime
    ? getDayWithFormat(DATE_FORMAT_EN, csvDateTime)
    : csvDateTime
}

export const convertDataExportExcel = (
  data: SchedulesListDataType[],
): SchedulesExportExcelFRM304Type[] => {
  const listIndexTravelerId: number[][] = []
  const travelerIds: string[] = []

  data.forEach((item, index) => {
    const travelerId = item.info.travelerId
    const travelerIdIndex = travelerIds.indexOf(travelerId)

    if (travelerIdIndex === -1) {
      travelerIds.push(travelerId)
      listIndexTravelerId.push([index])
    } else {
      listIndexTravelerId[travelerIdIndex].push(index)
    }
  })

  const lastElements = listIndexTravelerId.map(
    (subArray) => subArray[subArray.length - 1],
  )
  const _data = data.filter((_, index) => lastElements.includes(index))

  return _data.map((item) => ({
    departureDateTimeAndArrivalDateTime: `${getDisplayDateTime(
      item.info.dispatchStartDate,
    )}～${getDisplayDateTime(item.info.dispatchEndDate)}`,
    dispatchTypeDetailName: getDispatchTypeDetailName(
      item.info.bumonName,
      item.info.dispatchTypeDetailId,
      item.info.dispatchTypeDetailName,
      true,
    ),
    fullNameKanji: getFullName(
      item.info.kanjiSurname,
      item.info.kanjiName,
      true,
    ),
    fullNameRomaji: getFullName(item.info.romajiSurname, item.info.romajiName),
    groupName: KEYS_ACCOMPANYING_FAMILY.includes(item.info.dispatchTypeDetailId)
      ? item.info.personDispatcherName
      : item.info.organizationName.split("・")[0],
    locationPersonName: item.info.locationPersonName,
    othersRemarks1: item.csv.othersRemarks1,
    personEmailAddress: item.info.emailAddress1,
    phoneNumber: item.info.locationPhoneNumber1,
    projectNameJpOrProjectNameEn: getValueByLanguage(
      item.info.projectNameJp,
      item.info.projectNameEn,
    ).toString(),
    travelerLocation: item.info.travelerLocation || "",
    travelPurposeName: item.info.travelPurposeName,
    workPlaceCountryAndWorkPlaceCity: `${item.info.workPlaceCountry} ${item.info.workPlaceCity}`,
  }))
}
